import { isAllowedQrImageUrl } from "./input-validation";

const MINUTE_SECOND_PATTERN = /^(\d+)\s*分(?:钟)?\s*(\d+)\s*秒$/;
const MINUTE_PATTERN = /^(\d+)\s*分钟?$/;
const SECOND_PATTERN = /^(\d+)\s*秒$/;

export function parseTopicDurationToSeconds(value: unknown): number | null {
  const text = typeof value === "string" ? value.trim() : "";
  if (!text) return null;

  const minuteSecond = text.match(MINUTE_SECOND_PATTERN);
  if (minuteSecond) {
    // X分Y秒 一律按 X × 60 + Y 换算，秒数允许大于 59（如“3分99秒”= 279 秒），
    // 保证历史异常数据仍可参与时长区间筛选，而不被整体排除。
    return Number(minuteSecond[1]) * 60 + Number(minuteSecond[2]);
  }

  const minute = text.match(MINUTE_PATTERN);
  if (minute) return Number(minute[1]) * 60;

  const second = text.match(SECOND_PATTERN);
  if (second) return Number(second[1]);

  return null;
}

export function isValidTopicDuration(value: unknown): boolean {
  return parseTopicDurationToSeconds(value) !== null;
}

export function isValidPreviewAssetUrl(value: unknown): boolean {
  const text = typeof value === "string" ? value.trim() : "";
  return isAllowedQrImageUrl(text);
}

export function isRequiredResourceContent(value: unknown): boolean {
  // 领取资源内容：任意非空内容均允许（纯文字、数字、HTTP/HTTPS、任意域名、
  // 链接加提取码或说明），仅拒绝空字符串与纯空白。
  if (typeof value !== "string") return false;
  return value.trim().length > 0;
}
